
            const data = {"name":"columns","data":{"width":"30","height":"20","viewBox":"0 0 30 20","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 2h19.695v7.333H5V2Zm0 8.667h19.695V18H5v-7.333Z\" _fill=\"#333\"/>","originalColors":[{"type":"fill","color":"#333"}],"stopColors":[]}}
        
                module.exports = data
                